import {gsap} from 'gsap';
import {MutableRefObject, useEffect} from "react";

const useFullWidthTransition = (container: MutableRefObject<HTMLDivElement>, fullWidth: boolean, breakpoint: number, duration: number, ease: string | gsap.EaseFunction) => {

    useEffect(() => {
        const element = container.current;
        if (!element) {
            return;
        }

        const bounds = element.getBoundingClientRect();
        const parentBounds = element.parentElement.getBoundingClientRect();
        const baseTweenVars = {
            duration,
            ease,
        };

        if (fullWidth) {
            element.style.position = 'fixed';
            element.style.willChange = 'top';
            element.style.width = `${bounds.width}px`;
            element.style.top = `${bounds.top}px`;
            element.style.left = `${bounds.left}px`;
            element.style.zIndex = '999';
            const endWidth = window.innerWidth > breakpoint ? window.innerWidth * .8 : window.innerWidth;
            const endLeft = (window.innerWidth / 2) - (endWidth / 2);
            const endHeight = endWidth * (bounds.height / bounds.width);
            const tween = gsap
                .fromTo(
                    element,
                    {
                        left: `${bounds.left}px`,
                        top: `${bounds.top}px`,
                        width: `${bounds.width}px`,
                    },
                    {
                        ...baseTweenVars,
                        left: `${endLeft}px`,
                        top: `${window.innerHeight / 2 - (endHeight / 2)}`,
                        width: `${endWidth}px`,
                    },
                );

            const onResize = () => {
                tween.kill();
                const newEndWidth = window.innerWidth > breakpoint ? window.innerWidth * .8 : window.innerWidth;
                const newEndLeft = (window.innerWidth / 2) - (newEndWidth / 2);
                const newEndHeight = newEndWidth * (bounds.height / bounds.width);
                const newTop = window.innerHeight / 2 - (newEndHeight / 2);
                element.style.left = `${newEndLeft}px`;
                element.style.top = `${newTop}px`;
                element.style.width = `${newEndWidth}px`;
            };

            window.addEventListener('resize', onResize);

            return () => {
                tween.kill();
                window.removeEventListener('resize', onResize);
            };
        } else {
            const tween = gsap.fromTo(
                element,
                {
                    left: `${bounds.left}px`,
                    top: `${bounds.top}px`,
                    width: `${bounds.width}px`,
                },
                {
                    ...baseTweenVars,
                    left: `${parentBounds.left}px`,
                    top: `${parentBounds.top}px`,
                    width: `${parentBounds.width}px`,
                    onComplete: () => {
                        element.style.position = 'initial';
                        element.style.width = 'inherit';
                        element.style.aspectRatio = 'inherit';
                        element.style.left = 'initial';
                        element.style.top = 'initial';
                        element.style.transform = 'initial';
                        element.style.zIndex = 'initial';
                    },
                },
            );

            return () => {
                tween.kill();
            };
        }
    }, [container, fullWidth, breakpoint, duration, ease]);
};

export default useFullWidthTransition;
